import { useMutation } from 'react-query';
import { useActions } from '../../../../context/Actions.context';
import Endpoints from '../../../constants/endpoints';
import { useServices } from '../../../services/useServices';
import { IGetBookListParams } from '../book.dto';

export const useUnmuteAuthor = (name) => {
  const {
    book: { unmuteAuthor }
  } = useServices();

  const { source: sourcePath } = useActions();
  const sourceTab = window.location.pathname.split('/')[2];

  return useMutation(
    'unmute-author',
    (param: IGetBookListParams) =>
      unmuteAuthor(
        {
          source: sourcePath['source'],
          sourceTab,
          endpoint: Endpoints[name],
          action: name
        },
        param
      )
  );
};